import themeColors, { themeFontWeights, themeFonts, themeFontsSize } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";


const mapStateToProps = (state: ApplicationState) =>  ({
   
        session: state.context.session,  
});

type Props = ReturnType<typeof mapStateToProps> & PageProps;

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    contactUsLink?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin: 0 auto;
            max-width: 1220px;
            padding: 18px 10px;
            gap: 16px;

            @media screen and (max-width: 1340px) {
                padding: 18px 10px;
            }


            .header-form {
                display: inline-block;
                width: 100%;
                max-width: 28.5%;
                float: right;
                vertical-align: top;
                text-align: left;

                button {
                    min-height: auto;
                    text-transform: capitalize;
                }

                @media screen and (min-width: 768px) and (max-width: 1095px) {
                      max-width: 46%;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0;
                            gap: 0;
                            margin: 20px 0;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    logoWrapper: {
        css: css`
            display: inline-block;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                max-height: 67px;
                // min-width: 166px;
                margin-top: -10px;
                height: 100%;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                width: 100%;
                                min-width: 171px;
                                max-width: 171px;
                                min-height: 68px;
                                max-height: 68px;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            .home-page-link {
                display: flex;
                justify-content: center;
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            display: inline-block;
            margin: 0 20px;

            @media screen and (min-width: 1220px) {
                margin: 0 20px 0 55px; 
            }

            &.nav-links {
                .links-wrapper {
                    padding: 0;
                }
                .container,
                .list-wrapper {
                    padding: 5px 0;
                }
                .list-link {
                    padding: 0 0.8em;
                    font-size: ${themeFontsSize.size12};
                    border-right: 1px solid ${themeColors.lightGray};

                    &:hover {
                        text-decoration: underline;
                    }
                }
                .links-wrapper:last-child {
                    .list-link {
                        border-right: none;
                        border-left: 1px solid ${themeColors.lightGray};
                    }
                }
                .links-wrapper:nth-last-child(2) {
                    .list-link {
                        border-right: none;
                    }
                } 
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "md",
        css: css`

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            .wrapperLoggedIn {
                                display: flex;
                                justify-content: flex-end;
                            }
                            .wrapperGuest {
                                display: flex;
                                justify-content: flex-end;
                                gap: 5px 1rem;
                                flex-wrap: wrap;
                                .nav-links {
                                    .container {
                                        justify-content: center;
                                    }
                                }
                            }
                        `,
                    ],
                    "min",
                );
            }}
            @media screen and (min-width: 768px) and (max-width: 1023px) {
                .wrapperGuest {
                    display: block;
                    .nav-links {
                        width: auto;
                        .container {
                            justify-content: center;
                        }
                    }
                }
               
            }
            @media screen and (min-width: 992px) and (max-width: 1140px) {
                .wrapperGuest {
                    gap: 5px 0;
                }
            }
            @media screen and (min-width: 1024px) {
                .wrapperGuest {
                    flex-wrap: nowrap;
                }
            }
            @media screen and (min-width: 1220px) {
                .wrapperGuest {
                    > .nav-links {
                        margin-left: 0; 
			            margin-right: 0; 
                    }
                }
            }
        `
    },
    contactUsLink: {
        css: css`
            text-align: center;
            font: ${themeFontWeights.fontWeightForBold} ${themeFontsSize.size17} ${themeFonts.fontFamilyMuseoSans};
            &.guest-link {
                text-align: center;
                padding-top: 8px;
            }
            &.linkForTablet {
                display: none;
            }
            &.authenticated-link {
                padding: 8px 0;
               
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            white-space: nowrap;
                            &.authenticated-link {
                                margin-left: 20px;
                            }
                        `,
                        css`
                            &.authenticated-link {
                                margin-right: 5rem;
                            }
                        `,
                    ],
                    "min",
                );
            }}

           @media screen and (min-width: 768px) and (max-width: 1023px) {
                &.guest-link { 
                    display: none;
                }
                &.linkForTablet {
                    display: inline-block !important;
                    width: 50%;
                }
            }
            
        `
    }
};
const customCssWrapper = {
    css: css`
        @media screen and (min-width: 768px) {
            margin-top: 16px;
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, .2);
            margin-bottom: -14px;
        }
    `,
};
const LogoLinksSearch: React.FC<Props> = ({ id, session }) => {

    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
   
    return(
        <StyledWrapper className={`header-wrapper ${isAuthenticated ? 'autheticatedUserSection' : 'guestUserSection'}`} {...customCssWrapper}>
            <StyledWrapper className="logo-and-links-wrapper" {...logoLinksSearchStyles.container}>
                <StyledWrapper {...logoLinksSearchStyles.logoWrapper} className="site-logo-wrapper">
                    <Zone contentId={id} zoneName="Logo" />
                </StyledWrapper>
                <Hidden {...logoLinksSearchStyles.linkListHidden}>
                    <StyledWrapper className={isAuthenticated ? 'wrapperLoggedIn' : 'wrapperGuest'}>
                        {isAuthenticated && (
                            <StyledWrapper className="contactUsLink authenticated-link" {...logoLinksSearchStyles.contactUsLink}>
                                <Zone contentId={id} zoneName="contactUsLink" />
                            </StyledWrapper>
                        )}
                        <StyledWrapper className="nav-links" {...logoLinksSearchStyles.searchMenuWrapper}>
                            <Zone contentId={id} zoneName="LinkList" />
                            {!isAuthenticated && (
                                <StyledWrapper className="contactUsLink guest-link" {...logoLinksSearchStyles.contactUsLink}>
                                    <Zone contentId={id} zoneName="contactUsLink" />
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                        {!isAuthenticated && (
                            <StyledWrapper className="contactUsLink guest-link linkForTablet" {...logoLinksSearchStyles.contactUsLink}>
                                <Zone contentId={id} zoneName="contactUsLink" />
                            </StyledWrapper>
                        )}
                        {!isAuthenticated && (
                            <StyledWrapper className="header-form">
                                <Zone contentId={id} zoneName="HeaderFormSignIn" />
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </Hidden>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const logoLinksSearch: WidgetModule = {
    component: connect(mapStateToProps)(LogoLinksSearch),
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
